import { parseLanguageFromPathName } from '../../util/language-util';
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import { useLocation } from '@reach/router';
import * as classes from './nav-footer.module.css'
import React from 'react'

const NavFooter: React.FC = () => {
  try {
    const location = useLocation();
    const parsedLanguage = parseLanguageFromPathName(location.pathname)
    
    return (
      <div className={classes.container}>
        <div className={classes.snsContainer}>
          <a href={'https://www.tiktok.com/@daarbit'}>
            <StaticImage 
              src={'../../assets/icons/tiktok-white-icon.png'}
              className={classes.snsIcon} 
              alt={'daarbit tiktok'}
            />
          </a>
          <a href={'https://www.instagram.com/daarbit'}>
            <StaticImage 
              src={'../../assets/icons/instagram-white-icon.png'}
              className={classes.snsIcon} 
              alt={'daarbit instagram'}
            />
          </a>
          <a href={'https://www.youtube.com/@daarbit'}>
            <StaticImage 
              src={'../../assets/icons/youtube-white-icon.png'}
              className={classes.snsIcon} 
              alt={'daarbit youtube'}
            />
          </a>
          <a href={'https://x.com/daarbit_com'}>
            <StaticImage 
              src={'../../assets/icons/x-white-icon.png'}
              className={classes.snsIcon} 
              alt={'daarbit x'}
            />
          </a>
        </div>
        <Link 
          to={
            parsedLanguage == 'ko'
            ? '/ko/privacy-policy'
            : '/privacy-policy'
          }
          className={classes.footerMenuItem}
        >
          {
            parsedLanguage == 'ko'
            ? '개인정보처리방침'
            : 'privacy policy'
          }
        </Link>
      </div>
    )
  } catch (e) {return null}
}

export default NavFooter;